import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconClose = ({ ...props }: SvgIconProps) => (
  <SvgIcon sx={{ height: '24px', width: '24px' }} viewBox="0 0 24 24" {...props}>
    <path d="M4.80078 19.1998L19.2008 4.7998" stroke="#202723" />
    <path d="M4.79922 4.7998L19.1992 19.1998" stroke="#202723" />
  </SvgIcon>
);
